import type { MessageIndex } from "@/scripts/build-message-index"

let cached: MessageIndex | null = null

/** Lazily import the generated index (edit-only chunk; never in the public bundle). */
export async function loadMessageIndex(): Promise<MessageIndex> {
  if (cached) return cached
  const mod = await import("./message-index.generated.json")
  cached = mod.default as MessageIndex
  return cached
}
